module.exports = __webpack_public_path__ + "static/media/sidebar-collapse-curve.e97b0403.svg";